import React, { useCallback } from 'react';
import { PromptConfirmationModal } from 'ui';
import { AdministrationMessagesTranslation } from '../constants';
import { replaceTemplateString } from 'app/infrastructure/platform';

interface DeleteMessageMenuProps {
  id: number;
  subject: string;
  onDelete: (id: number, successMessage: string) => void;
  disabled: boolean;
  translation: AdministrationMessagesTranslation;
}

export const DeleteMessageMenu: React.FC<DeleteMessageMenuProps> = ({
  id, subject, onDelete, disabled, translation
}) => {

  const onClick = useCallback(
    () => {
      !!id && onDelete(id, translation.message_deleted);
    },
    [id]
  );

  return <PromptConfirmationModal
    title={translation.delete_message_title}
    description={replaceTemplateString(
      translation.delete_message_confirm,
      subject)}
    continueText={translation.delete_message_button}
    cancelText={translation.cancel}
    onContinue={onClick}>
    <button type="button" className="dropdown-item" disabled={disabled}>
      {translation.delete_message_button}
    </button>
  </PromptConfirmationModal>;
};
